import React, { forwardRef } from 'react';
import { StyleProp, TextInput, View, ViewStyle } from 'react-native';
import { getSpacing } from '../../../utils/spacing';
import { textVariantStyleMap } from '../../v2BaseComponents/Text';
import Icon from '../../v2BaseComponents/Icon';

export type SearchInputOwnProps = {
    style: StyleProp<ViewStyle>;
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
};

export type SearchInputProps = SearchInputOwnProps & React.RefAttributes<TextInput>;

const SearchInput: React.FC<SearchInputProps> = forwardRef((props, ref) => {
    const textStyle = textVariantStyleMap[props.value ? 'ai-search-input-text' : 'ai-search-input-placeholder-text'];

    return (
        <View
            style={[
                {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                },
                props.style,
            ]}
        >
            <Icon name="Search" colorVariant={props.value ? 'Dark-Text' : 'Gray-Text'} size={'ai-search-icon'} />
            <TextInput
                style={[
                    textStyle,
                    {
                        lineHeight: 26,
                        paddingHorizontal: getSpacing(3),
                        paddingVertical: getSpacing(1),
                        borderColor: 'transparent',
                        ...({ outlineStyle: 'none' } as any),
                        overflow: 'show',
                        alignSelf: 'stretch',
                        fontSize: 18,
                        flex: 1,
                    },
                ]}
                placeholder="Search"
                ref={ref}
                value={props.value}
                onChange={(e) => {
                    props.onChange(e.nativeEvent.text);
                }}
                testID="ai-search-input"
            />
        </View>
    );
});

export default React.memo(SearchInput);
